module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/TK-bedb686ef56c15ec45cac094518d32c2.png";